import { useDispatch } from 'react-redux';
import { closeModal } from '../../../../../reducers/modalReducer';

export const useCloseConfigureModal = (isPending: boolean) => {
  const dispatch = useDispatch();

  return () => {
    if (isPending) return;
    dispatch(closeModal());
  };
};
